import { Loader, Select, type SelectProps } from "@mantine/core";

import { SYSTEM_COLORS } from "@/configs/colorScheme";

export interface FormFieldSelectProps extends SelectProps {
  loading?: boolean;
}

export const FormFieldSelect = ({ loading, data, ...props }: FormFieldSelectProps) => {
  const deduplicatedData = [...new Set(data)];
  return (
    <Select
      allowDeselect={!props.required}
      clearable={!props.required}
      placeholder={typeof props.label === "string" ? props.label : undefined}
      checkIconPosition="right"
      maxDropdownHeight="16rem" // TODO: extract to global selector config
      searchable
      selectFirstOptionOnChange
      rightSection={loading ? <Loader size={18} /> : undefined}
      withAsterisk={(props.required && !props.readOnly) ?? undefined}
      variant={props.readOnly ? "unstyled" : undefined}
      comboboxProps={{
        keepMounted: false,
        ...props.comboboxProps,
      }}
      styles={{
        label: {
          color: props.readOnly ? SYSTEM_COLORS.default : undefined,
        },
      }}
      data={deduplicatedData}
      {...props}
    />
  );
};

export default FormFieldSelect;
